import { cx, css } from '@emotion/css';
import React__default from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { useTheme2, InlineField } from '@grafana/ui';
import { OperationEditorBody } from './OperationEditorBody.js';

function OperationEditor({
  operation,
  index,
  onRemove,
  onChange,
  onRunQuery,
  queryModeller,
  query,
  datasource,
  flash,
  highlight,
  timeRange,
  isConflictingOperation
}) {
  const def = queryModeller.getOperationDefinition(operation.id);
  const theme = useTheme2();
  const isConflicting = isConflictingOperation ? isConflictingOperation(operation, query.operations) : false;
  const styles = getStyles(theme);
  if (!def) {
    return /* @__PURE__ */ React__default.createElement("span", null, "Operation ", operation.id, " not found");
  }
  const isInvalid = (isDragging) => {
    if (isDragging) {
      return void 0;
    }
    return isConflicting ? true : void 0;
  };
  return /* @__PURE__ */ React__default.createElement(Draggable, { draggableId: `operation-${index}`, index }, (provided, snapshot) => /* @__PURE__ */ React__default.createElement(
    InlineField,
    {
      error: "You have conflicting label filters",
      invalid: isInvalid(snapshot.isDragging),
      className: cx(styles.error, styles.cardWrapper)
    },
    /* @__PURE__ */ React__default.createElement(
      OperationEditorBody,
      {
        provided,
        flash,
        highlight,
        isConflicting,
        index,
        operation,
        definition: def,
        onChange,
        onRemove,
        queryModeller,
        query,
        timeRange,
        onRunQuery,
        datasource
      }
    )
  ));
}
const getStyles = (theme, isConflicting) => {
  return {
    cardWrapper: css({
      alignItems: "stretch"
    }),
    error: css({
      marginBottom: theme.spacing(1)
    })
  };
};

export { OperationEditor };
//# sourceMappingURL=OperationEditor.js.map
